import { CardActions, CardContent } from "@mui/material";
import { Button } from "component/MarketPlace/ButtonComponents";
import Typography from "component/MarketPlace/Typography/Typography";
import React from "react";
import { StyledCard } from "./index.style";
import parse from 'html-react-parser';
import { useTheme } from "styled-components";
import { handleKeyPress } from 'utils/functions';

export interface IBannerCard {
  openChat: () => void;
  endIcon?: any;
  chatBotName?: string;
  overlineBanner?: string;
  locale?: any;
  askText?: string;
  isShowOverlineBanner: boolean;
}
const BannerCard = (props: IBannerCard) => {
  const { openChat, endIcon, chatBotName, overlineBanner, locale, askText, isShowOverlineBanner } = props;
  const theme = useTheme();

  return (
    <StyledCard elevation={0}>
      {isShowOverlineBanner && (
      <Typography variant="overline" color="primary.main"  tabIndex={0}>
        {overlineBanner?.toUpperCase() || 'UPTIME VIRTUAL ASSISTANT'}
      </Typography>
      )}
      <CardContent tabIndex={0} role="contentinfo">
        <Typography variant="h5" color="text.primary">
          {parse(locale?.titleBanner || 'Not sure where to start?<br></br>Ask me.')}
        </Typography>
        <Typography variant="body2" color="text.secondary" marginTop="5px">
        {parse(locale?.descriptionBanner || 'Get help with IT issues, search knowledge, create tickets, connect with a live support agent and more.<br></br>You could even ask, Do I need an umbrella for tomorrow?')}
        </Typography>
      </CardContent>
      <CardActions>
        <Button 
          onClick={openChat} 
          onKeyDown={(e: any) => handleKeyPress(e, 'Enter', openChat)}
          variant="contained" 
          endIcon={endIcon} 
          sx={{ fontSize: `${theme.uptimeDynamicFontSize?.bannerCard?.txtChatBtn}` }}
          tabIndex={0}
          aria-label={`Clickable to ${chatBotName ?? 'EVA'}`}
        >
          {`${askText || 'Ask' } ${chatBotName ?? 'EVA'}`}
        </Button>
      </CardActions>
    </StyledCard>
  );
};

export default BannerCard;
